import "./Header.scss";
import constants from "../../../constants";
import HeaderHooks from "./Hooks/HeaderHooks";
import { getDataFromStorage } from "../../../util";
import GradiousLogoSvg from "./Svg/GradiousLogoSvg";
import React, { useEffect, useContext } from "react";
import TestDueHooks from "../../../Hooks/TestDueHooks";
import AlertContext from "../../../context/AlertContext";
import InstructionPageBody from "../InstructionPage/InstructionPageBody";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import CodingHeaderLearnerSideHooks from "../../../Hooks/CodingPage/CodingHeaderLearnerSideHooks";

const { electronAPI } = window;

const Headers = () => {
  const Alert = useContext(AlertContext);

  const { currentDueLabel } = TestDueHooks();
  const { handleNavigate } = useCommonFunctionHooks();
  const CodingHeaderLearnerSideHks = CodingHeaderLearnerSideHooks();
  const { handleSubmitAssignmentOnSandpack } = HeaderHooks();

  let isLearner = getDataFromStorage("role") === "learner" ? true : false;

  const handleScreenChange = (event, screenStatus) => {
    if (screenStatus.type === "added") {
      Alert.setExternalDevices(true);
      Alert.setShowNotify({
        show: true,
        title: "Warning",
        msg: "You are connecting to external display!",
      });
    } else if (screenStatus.type === "removed") {
      Alert.setExternalDevices(false);
      Alert.setShowNotify({
        show: true,
        title: "Warning",
        msg: "You are disconnecting from external display!",
      });
    }
  };

  useEffect(() => {
    electronAPI?.onScreenChanged(handleScreenChange);

    return () => {
      electronAPI?.offScreenChanged(handleScreenChange);
    };
  }, []);

  useEffect(() => {
    if (
      !Alert.isAdmin &&
      Alert.showBreadCrumbsData.from !== "learner" &&
      Alert.status === constants.PROGRESS_STATUS.UNLOCKED &&
      Alert.testData.proctored !== constants.PROCTORING_MODE.NONE
    ) {
      Alert.setShowNotify({
        size: "lg",
        show: true,
        title: "Instruction",
        msg: <InstructionPageBody />,
      });
    }
  }, [Alert.isAdmin]);

  return (
    <header id="appHeader" className="headerforsp">
      <div className="headerBody">
        <div
          className="headerLogoAndName"
          onClick={() => {
            if (!isLearner) {
              handleNavigate();
            }
          }}
        >
          <GradiousLogoSvg />
          <div className="headerLogoAndNameName">Gradious</div>
        </div>

        <div className="containerforsandpackutils">
          <span
            className="sandpacksubmit"
            onClick={() => Alert.setShowInstructions(true)}
          >
            View Assignment
          </span>
          {(currentDueLabel(Alert.testData.duedate) !== "Past Due" && ( Alert?.contentData?.switchedcount < 10) || 
            parseInt(localStorage.getItem("batchType")) ===
              constants.BATCH_TYPE.SELF) &&
            Alert.status !== constants.PROGRESS_STATUS.EVALUATED &&
            isLearner && (
              <svg
                width="20"
                height="20"
                fill="none"
                onClick={() => handleSubmitAssignmentOnSandpack(false)}
                className={
                  Alert.status === constants.PROGRESS_STATUS.EVALUATED
                    ? "disablesavesandpack"
                    : "savesandpack"
                }
              >
                <path
                  stroke="#EAECF0"
                  className="savesp"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14.1667 17.5V10.8333H5.83333V17.5M5.83333 2.5V6.66667H12.5M15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H13.3333L17.5 6.66667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5Z"
                />
              </svg>
            )}
          {(currentDueLabel(Alert.testData.duedate) !== "Past Due" && ( Alert?.contentData?.switchedcount < 10) ||
            parseInt(localStorage.getItem("batchType")) ===
              constants.BATCH_TYPE.SELF) &&
            Alert.status !== constants.PROGRESS_STATUS.EVALUATED /* &&
            isLearner */ && (
              <span
                onClick={() => handleSubmitAssignmentOnSandpack(true, true)}
                className={
                  Alert.status === constants.PROGRESS_STATUS.EVALUATED
                    ? "disablesandpacksubmit"
                    : "sandpacksubmit"
                }
              >
                Submit
              </span>
            )}
        </div>
      </div>
    </header>
  );
};

export default Headers;
